module.exports = __webpack_public_path__ + "img/BNB.07c11f52.svg";